import { WsAccountDetails } from '@model/ftf-api.model';
import { createReducer, on } from '@ngrx/store';

import * as AccountActions from '../actions/account.actions';

export interface AccountState {
  accountDetails: WsAccountDetails;
  isLoaded: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
}

/**
 * The initial state for the account feature.
 */
export const initialState: AccountState = {
  accountDetails: {
    firstName: '',
    lastName: '',
    emailAddress: '',
    userName: '',
    clientName: 'default',
    userSubjectToExportControl: 'N',
    customFields: {},
    preferences: {},
    roles: [],
    patentTrifoldOrder: 'L,M,R',
    tmTrifoldOrder: 'L,M,R',
    matterTrifoldOrder: 'L,M,R',
  },
  isLoaded: false,
  error: null,
};

/**
 * The reducer function for the account feature.
 */
export const accountReducer = createReducer(
  initialState,
  on(AccountActions.loadAccountDetailsSuccess, (state, { accountDetails }) => ({
    ...state,
    accountDetails,
    isLoaded: true,
    error: null,
  })),
  on(AccountActions.loadAccountDetailsFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(AccountActions.resetAccountState, () => initialState)
);
